import React from 'react';

export const MenuLogo = () => {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="15" cy="15" r="15" fill="#9CA8BB" />
            <path
                d="M16.1741 21.9515L8.85352 14.6345L16.1741 7.31738L17.4735 8.61616L11.4523 14.6345L17.4735 20.6527L16.1741 21.9515Z"
                fill="white"
            />
        </svg>
    );
};

export const HomeLogo = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="Icons">
                <path id="Vector" d="M4 21V9L12 3L20 9V21H14V14H10V21H4Z" fill="#9CA8BB" />
            </g>
        </svg>
    );
};

export const SMSInsightsLogo = () => {
    return (
        <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="Icons">
                <path
                    id="Vector"
                    d="M3.5 21V19L5.5 17V21H3.5ZM7.5 21V15L9.5 13V21H7.5ZM11.5 21V13L13.5 15.025V21H11.5ZM15.5 21V15.025L17.5 13.025V21H15.5ZM19.5 21V11L21.5 9V21H19.5ZM3.5 15.825V13L10.5 6L14.5 10L21.5 3V5.825L14.5 12.825L10.5 8.825L3.5 15.825Z"
                    fill="#9CA8BB"
                />
            </g>
        </svg>
    );
};

export const DataTableLogo = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="Table">
                <rect x="1" y="1" width="22" height="22" stroke="#9CA8BB" strokeWidth="2" fill="none" />
                <line x1="8" y1="1" x2="8" y2="23" stroke="#9CA8BB" strokeWidth="2" />
                <line x1="16" y1="1" x2="16" y2="23" stroke="#9CA8BB" strokeWidth="2" />
                <line x1="1" y1="8" x2="23" y2="8" stroke="#9CA8BB" strokeWidth="2" />
            </g>
        </svg>
    );
};

export const GraphLogo = () => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20.3571 6.5L13.0714 12.0714L19.5714 18.5714C21.0714 16.7857 22 14.5 22 12C22 9.92857 21.3571 8.07143 20.3571 6.5Z"
          fill="#9CA8BB"/>
        <path
          d="M12.7143 10.5714L19.4286 5.35714C17.7143 3.5 15.3572 2.21429 12.7143 2V10.5714Z"
          fill="#9CA8BB"/>
        <path
          d="M11.5 12.4999C11.4286 12.4284 11.4286 12.4284 11.5 12.4999C11.4286 12.4284 11.4286 12.357 11.4286 12.357C11.4286 12.2856 11.3571 12.2856 11.3571 12.2141C11.3571 12.1427 11.3571 12.1427 11.3571 12.0713V11.9999V2.07129C6.07143 2.42843 2 6.71415 2 11.9999C2 17.4999 6.5 21.9999 12 21.9999C14.5 21.9999 16.7857 21.0713 18.5714 19.5713L11.5 12.4999Z"
          fill="#9CA8BB"/>
      </svg>
    );
};

export const ContactsLogo = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icons">
        <path
          id="Vector"
          d="M4 23V21H20V23H4ZM4 3V1H20V3H4ZM12 13C12.8333 13 13.5417 12.7083 14.125 12.125C14.7083 11.5417 15 10.8333 15 10C15 9.16667 14.7083 8.45833 14.125 7.875C13.5417 7.29167 12.8333 7 12 7C11.1667 7 10.4583 7.29167 9.875 7.875C9.29167 8.45833 9 9.16667 9 10C9 10.8333 9.29167 11.5417 9.875 12.125C10.4583 12.7083 11.1667 13 12 13ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM5.75 18H18.25C17.5 17.0667 16.5917 16.3333 15.525 15.8C14.4583 15.2667 13.2833 15 12 15C10.7167 15 9.54167 15.2667 8.475 15.8C7.40833 16.3333 6.5 17.0667 5.75 18Z"
                    fill="#9CA8BB"
                />
            </g>
        </svg>
    );
};



export const SMSLogo = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="Icons">
                <path
                    id="Vector"
                    d="M12 0C5.37187 0 0 4.9875 0 11.1429C0 13.8 1.00312 16.2321 2.67188 18.1446C2.08594 20.8446 0.126562 23.25 0.103125 23.2768C0 23.4 -0.028125 23.5821 0.0328125 23.7429C0.09375 23.9036 0.225 24 0.375 24C3.48281 24 5.8125 22.2964 6.96562 21.2464C8.49844 21.9054 10.2 22.2857 12 22.2857C18.6281 22.2857 24 17.2982 24 11.1429C24 4.9875 18.6281 0 12 0ZM6.00938 14.5714H5.4375C5.23125 14.5714 5.0625 14.3786 5.0625 14.1429V13.2857C5.0625 13.05 5.23125 12.8571 5.4375 12.8571H6.01406C6.29531 12.8571 6.50156 12.6696 6.50156 12.5036C6.50156 12.4339 6.46406 12.3589 6.40312 12.3L5.37656 11.2929C4.97813 10.9071 4.75312 10.3554 4.75312 9.7875C4.75312 8.64643 5.64375 7.71964 6.74062 7.71964H7.3125C7.51875 7.71964 7.6875 7.9125 7.6875 8.14821V9.00536C7.6875 9.24107 7.51875 9.43393 7.3125 9.43393H6.73594C6.45469 9.43393 6.24844 9.62143 6.24844 9.7875C6.24844 9.85714 6.28594 9.93214 6.34687 9.99107L7.37344 10.9982C7.77187 11.3839 7.99687 11.9357 7.99687 12.5036C8.00156 13.6446 7.10625 14.5714 6.00938 14.5714ZM15 14.1429C15 14.3786 14.8312 14.5714 14.625 14.5714H13.875C13.6687 14.5714 13.5 14.3786 13.5 14.1429V10.4893L12.3375 13.4786C12.2016 13.7946 11.8031 13.7946 11.6672 13.4786L10.5 10.4893V14.1429C10.5 14.3786 10.3313 14.5714 10.125 14.5714H9.375C9.16875 14.5714 9 14.3786 9 14.1429V8.57143C9 8.1 9.3375 7.71429 9.75 7.71429H10.5C10.7859 7.71429 11.0437 7.89643 11.1703 8.18571L12 10.0821L12.8297 8.18571C12.9562 7.89643 13.2188 7.71429 13.5 7.71429H14.25C14.6625 7.71429 15 8.1 15 8.57143V14.1429ZM17.2641 14.5714H16.6875C16.4812 14.5714 16.3125 14.3786 16.3125 14.1429V13.2857C16.3125 13.05 16.4812 12.8571 16.6875 12.8571H17.2641C17.5453 12.8571 17.7516 12.6696 17.7516 12.5036C17.7516 12.4339 17.7141 12.3589 17.6531 12.3L16.6266 11.2929C16.2281 10.9071 16.0031 10.3554 16.0031 9.7875C16.0031 8.64643 16.8937 7.71964 17.9906 7.71964H18.5625C18.7687 7.71964 18.9375 7.9125 18.9375 8.14821V9.00536C18.9375 9.24107 18.7687 9.43393 18.5625 9.43393H17.9859C17.7047 9.43393 17.4984 9.62143 17.4984 9.7875C17.4984 9.85714 17.5359 9.93214 17.5969 9.99107L18.6234 10.9982C19.0219 11.3839 19.2469 11.9357 19.2469 12.5036C19.2516 13.6446 18.3609 14.5714 17.2641 14.5714Z"
                    fill="#9CA8BB"
                />
            </g>
        </svg>
    );
};


export const EmailLogo = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="Icons">
                <path
                    id="Vector"
                    d="M19 23L17.6 21.6L19.175 20H15V18H19.175L17.575 16.4L19 15L23 19L19 23ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V13.8C21.55 13.5333 21.0708 13.3333 20.5625 13.2C20.0542 13.0667 19.5333 13 19 13C17.3333 13 15.9167 13.5833 14.75 14.75C13.5833 15.9167 13 17.3333 13 19V20H4ZM12 13L20 8V6L12 11L4 6V8L12 13Z"
                    fill="#9CA8BB"
                />
            </g>
        </svg>
    );
};


export const DevelopersLogo = () => {
    return (
        <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="Icons">
                <path
                    id="Vector"
                    d="M10.1 15.6L11.5 14.15L9.35 12L11.5 9.85L10.1 8.4L6.5 12L10.1 15.6ZM14.9 15.6L18.5 12L14.9 8.4L13.5 9.85L15.65 12L13.5 14.15L14.9 15.6ZM5.5 21C4.95 21 4.47917 20.8042 4.0875 20.4125C3.69583 20.0208 3.5 19.55 3.5 19V5C3.5 4.45 3.69583 3.97917 4.0875 3.5875C4.47917 3.19583 4.95 3 5.5 3H9.7C9.91667 2.4 10.2792 1.91667 10.7875 1.55C11.2958 1.18333 11.8667 1 12.5 1C13.1333 1 13.7042 1.18333 14.2125 1.55C14.7208 1.91667 15.0833 2.4 15.3 3H19.5C20.05 3 20.5208 3.19583 20.9125 3.5875C21.3042 3.97917 21.5 4.45 21.5 5V19C21.5 19.55 21.3042 20.0208 20.9125 20.4125C20.5208 20.8042 20.05 21 19.5 21H5.5ZM12.5 4.25C12.7167 4.25 12.8958 4.17917 13.0375 4.0375C13.1792 3.89583 13.25 3.71667 13.25 3.5C13.25 3.28333 13.1792 3.10417 13.0375 2.9625C12.8958 2.82083 12.7167 2.75 12.5 2.75C12.2833 2.75 12.1042 2.82083 11.9625 2.9625C11.8208 3.10417 11.75 3.28333 11.75 3.5C11.75 3.71667 11.8208 3.89583 11.9625 4.0375C12.1042 4.17917 12.2833 4.25 12.5 4.25Z"
                    fill="#9CA8BB"
                />
            </g>
        </svg>
    );
};

export const APILogo = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="Icons">
                <path
                    id="Vector"
                    d="M12 15.3746L6 9.37461L7.4 7.97461L12 12.5746L16.6 7.97461L18 9.37461L12 15.3746Z"
                    fill="#9CA8BB"
                />
            </g>
        </svg>
    );
};


export const HelpLogo = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="Icons">
                <path
                    id="Vector"
                    d="M11.95 18C12.3 18 12.5958 17.8792 12.8375 17.6375C13.0792 17.3958 13.2 17.1 13.2 16.75C13.2 16.4 13.0792 16.1042 12.8375 15.8625C12.5958 15.6208 12.3 15.5 11.95 15.5C11.6 15.5 11.3042 15.6208 11.0625 15.8625C10.8208 16.1042 10.7 16.4 10.7 16.75C10.7 17.1 10.8208 17.3958 11.0625 17.6375C11.3042 17.8792 11.6 18 11.95 18ZM11.05 14.15H12.9C12.9 13.6 12.9625 13.1667 13.0875 12.85C13.2125 12.5333 13.5667 12.1 14.15 11.55C14.5833 11.1167 14.925 10.7042 15.175 10.3125C15.425 9.92083 15.55 9.45 15.55 8.9C15.55 7.96667 15.2083 7.25 14.525 6.75C13.8417 6.25 13.0333 6 12.1 6C11.15 6 10.3792 6.25 9.7875 6.75C9.19583 7.25 8.78333 7.85 8.55 8.55L10.2 9.2C10.2833 8.9 10.4708 8.575 10.7625 8.225C11.0542 7.875 11.5 7.7 12.1 7.7C12.6333 7.7 13.0333 7.84583 13.3 8.1375C13.5667 8.42917 13.7 8.75 13.7 9.1C13.7 9.43333 13.6 9.74583 13.4 10.0375C13.2 10.3292 12.95 10.6 12.65 10.85C11.9167 11.5 11.4667 11.9917 11.3 12.325C11.1333 12.6583 11.05 13.2667 11.05 14.15ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
                    fill="#9CA8BB"
                />
            </g>
        </svg>
    );
};


export const ReportIssueLogo = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="Icons">
                <path
                    id="Vector"
                    d="M12 17C12.2833 17 12.5208 16.9042 12.7125 16.7125C12.9042 16.5208 13 16.2833 13 16C13 15.7167 12.9042 15.4792 12.7125 15.2875C12.5208 15.0958 12.2833 15 12 15C11.7167 15 11.4792 15.0958 11.2875 15.2875C11.0958 15.4792 11 15.7167 11 16C11 16.2833 11.0958 16.5208 11.2875 16.7125C11.4792 16.9042 11.7167 17 12 17ZM11 13H13V7H11V13ZM8.25 21L3 15.75V8.25L8.25 3H15.75L21 8.25V15.75L15.75 21H8.25Z"
                    fill="#9CA8BB"
                />
            </g>
        </svg>
    );
};

export const CloseLogo = () => {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="Icons">
                <path
                    id="Vector"
                    d="M12 17C12.2833 17 12.5208 16.9042 12.7125 16.7125C12.9042 16.5208 13 16.2833 13 16C13 15.7167 12.9042 15.4792 12.7125 15.2875C12.5208 15.0958 12.2833 15 12 15C11.7167 15 11.4792 15.0958 11.2875 15.2875C11.0958 15.4792 11 15.7167 11 16C11 16.2833 11.0958 16.5208 11.2875 16.7125C11.4792 16.9042 11.7167 17 12 17ZM11 13H13V7H11V13ZM8.25 21L3 15.75V8.25L8.25 3H15.75L21 8.25V15.75L15.75 21H8.25Z"
                    fill="#27AE60"
                />
            </g>
        </svg>
    )
}

export const CampaignCostLogo = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            >
            <path
                d="M11.1 19H12.85V17.75C13.6833 17.6 14.4 17.275 15 16.775C15.6 16.275 15.9 15.5333 15.9 14.55C15.9 13.85 15.7 13.2083 15.3 12.625C14.9 12.0417 14.1 11.5333 12.9 11.1C11.9 10.7667 11.2083 10.475 10.825 10.225C10.4417 9.975 10.25 9.63333 10.25 9.2C10.25 8.76667 10.4042 8.425 10.7125 8.175C11.0208 7.925 11.4667 7.8 12.05 7.8C12.5833 7.8 13 7.92917 13.3 8.1875C13.6 8.44583 13.8167 8.76667 13.95 9.15L15.55 8.5C15.3667 7.91667 15.0292 7.40833 14.5375 6.975C14.0458 6.54167 13.5 6.3 12.9 6.25V5H11.15V6.25C10.3167 6.43333 9.66667 6.8 9.2 7.35C8.73333 7.9 8.5 8.51667 8.5 9.2C8.5 9.98333 8.72917 10.6167 9.1875 11.1C9.64583 11.5833 10.3667 12 11.35 12.35C12.4 12.7333 13.1292 13.075 13.5375 13.375C13.9458 13.675 14.15 14.0667 14.15 14.55C14.15 15.1 13.9542 15.5042 13.5625 15.7625C13.1708 16.0208 12.7 16.15 12.15 16.15C11.6 16.15 11.1125 15.9792 10.6875 15.6375C10.2625 15.2958 9.95 14.7833 9.75 14.1L8.1 14.75C8.33333 15.55 8.69583 16.1958 9.1875 16.6875C9.67917 17.1792 10.3167 17.5167 11.1 17.7V19ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
                fill="#9CA8BB"
            />
        </svg>
    )
}

export const CreditLogo = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 69.571 69.571" fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
        <path
            d="M60.571,10.786H9c-4.962,0-9,4.038-9,9v30c0,4.963,4.038,9,9,9h51.571c4.963,0,9-4.037,9-9v-30 C69.571,14.823,65.534,10.786,60.571,10.786z M9,16.786h51.571c1.654,0,3,1.346,3,3v3.852H6v-3.852C6,18.132,7.346,16.786,9,16.786 z M60.571,52.785H9c-1.654,0-3-1.346-3-3V31.637h57.571v18.148C63.571,51.439,62.225,52.785,60.571,52.785z"/>
        </svg>
    )
}

export const SMSCampaignLogo = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.6 12.9V10.7H23V12.9H18.6ZM19.92 20.6L16.4 17.96L17.72 16.2L21.24 18.84L19.92 20.6ZM17.72 7.4L16.4 5.64L19.92 3L21.24 4.76L17.72 7.4ZM4.3 19.5V15.1H3.2C2.595 15.1 2.07708 14.8846 1.64625 14.4537C1.21542 14.0229 1 13.505 1 12.9V10.7C1 10.095 1.21542 9.57708 1.64625 9.14625C2.07708 8.71542 2.595 8.5 3.2 8.5H7.6L13.1 5.2V18.4L7.6 15.1H6.5V19.5H4.3ZM14.2 15.485V8.115C14.695 8.555 15.0938 9.09125 15.3962 9.72375C15.6987 10.3562 15.85 11.0483 15.85 11.8C15.85 12.5517 15.6987 13.2437 15.3962 13.8763C15.0938 14.5087 14.695 15.045 14.2 15.485Z"
        fill="#9CA8BB" />
    </svg>
  )
}
